<div class="vendor-search-container">
	<input pInputText [(ngModel)]="name" class="vendor-name" (keyup)="search()" [placeholder]="placeholder">
	<div class="options" [ngClass]="{open: vendors?.length > 0}">
		<div *ngFor="let vendor of vendors" (click)="selectVendor(vendor)">{{vendor.name}}</div>
	</div>
</div>
